<template>
  <div class="_taskView">
    <md-table :value="filteredTasks" class="paginated-table table-striped table-hover _taskView__table last_cell">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Task" md-sort-by="id">
          <span>{{ item.subject }}</span>
        </md-table-cell>
        
        <md-table-cell md-label="Steps" md-sort-by="name">
          <div class="_taskView__steps">
            <div class="_taskView__steps__header">
              <div class="_taskView__steps__title">
                <span>Steps List </span>
              </div>
            </div>
            <div class="_taskView__steps__list" v-if="item.steps && item.steps.items.length">
              <div v-for="_step in sortedSteps(item.steps.items)" :key="_step.id">
              <div class="_taskView__steps__step step_position">
                {{ _step.title }}
              </div>
              </div>
            </div>
          </div>
        </md-table-cell>
                
        <md-table-cell md-label="Status">
          <span>{{ item.status }}</span>
        </md-table-cell>

        <md-table-cell md-label="Priority" class="cell-align">
          <span>{{ item.priority }}</span>
        </md-table-cell>

      </md-table-row>
    </md-table>    
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    taskTemp: {
      type: Array,
      required: true,
    }
  },
  data: () => ({
    // 
  }),
  computed: {
    sortedTasks() {
      return _.sortBy(this.taskTemp, ['group', 'order']);
    },
    filteredTasks() {
      let tasks = this.sortedTasks;
      return tasks;
    },
  },
  methods: {
    sortedSteps(steps) {
      return _.sortBy(steps, 'order');
    }
  }
};
</script>

<style lang="scss">

.paginated-table .md-table-cell.cell-align .md-table-cell-container, .paginated-table.last_cell .md-table-head:last-child {
    text-align: left !important;
    display: table-cell;
}

._taskView__steps__step.step_position::before, ._taskView__steps__step.step_position::after {
    top: 73% !important;
}
</style>
